<app-transaction-result-view
[id]="id"
[shouldShowFlow]="true"
[title]="requestVariant === 'personal' ? 'Renovar mi licencia' : 'Renovar licencia para un empleado o contratista'"
[subtitle]="subtitle"
[messageBold]="messageBold"
[message]="message"
[actionButtonText]="actionButtonText"
[actionButtonPath]="actionButtonPath"
secondaryButtonText="Crear una nueva solicitud"
secondaryButtonPath="/license/renew"
[breadcrums]="breadcrums"
[actionButtonDescription]="actionButtonDescription"
[variant]="variant"
></app-transaction-result-view>
